import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

function* getNonConfirmityReportHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "nonconformityreport", ...action.payload }),
		);
		yield put({
			type: types.GET_NON_CONFORMITY_REPORT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_NON_CONFORMITY_REPORT_ERROR,
			payload,
		});
	}
}

export function* getNonConfirmityReportWatcherSaga() {
	yield takeLatest(
		types.GET_NON_CONFORMITY_REPORT_START,
		getNonConfirmityReportHandlerSaga,
	);
}

// get one
function* getOneNonConformityReportHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			`nonconformityreport/${action.payload}`,
		);
		yield put({
			type: types.SINGLE_NON_CONFORMITY_REPORT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.SINGLE_NON_CONFORMITY_REPORT_ERROR,
			payload,
		});
	}
}

export function* getOneNonConformityReportWatcherSaga() {
	yield takeLatest(
		types.SINGLE_NON_CONFORMITY_REPORT_START,
		getOneNonConformityReportHandlerSaga,
	);
}

// get one


//create

//delete

function* deleteNonConfirmityReportHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("nonconformityreport", action.payload),
		);
		yield put({
			type: types.DELETE_NON_CONFORMITY_REPORT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_NON_CONFORMITY_REPORT_ERROR,
			payload,
		});
	}
}

export function* deleteNonConfirmityReportWatcherSaga() {
	yield takeLatest(
		types.DELETE_NON_CONFORMITY_REPORT_START,
		deleteNonConfirmityReportHandlerSaga,
	);
}

//update
